// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"673":"fe2515ba","767":"08034225"}[chunkId] + ".chunk.js";
};